import { creators } from "@/mocks/creators";

export default function Rising() {
  const risingCreators = creators.filter((c) => c.tier === "rising");

  return (
    <section id="rising" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-medium text-accent-800">
              <i className="ri-seedling-line"></i>
              新锐力量
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              正在上升的潜力创作者
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              大V稳定，但新人往往更敢尝试、更新更勤、互动也更热情。这批创作者在各自细分领域开始被更多人看到，
              早点关注，说不定就陪着一个账号一起长大了。
            </p>
          </div>
          <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-5 py-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/12 text-accent-700">
              <i className="ri-rocket-2-line text-xl"></i>
            </span>
            <div>
              <p className="font-heading text-xl font-bold text-foreground-950">更新更勤</p>
              <p className="text-xs text-foreground-600">互动积极 · 风格正在成型</p>
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {risingCreators.map((creator) => (
            <article
              key={creator.id}
              className="flex flex-col rounded-lg border border-dashed border-background-300 bg-background-100 p-6 transition-colors hover:border-accent-300 hover:bg-background-50"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/12 text-accent-700">
                    <i className="ri-user-3-line text-xl"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {creator.name}
                    </h3>
                    <p className="text-[11px] text-foreground-500">{creator.level}</p>
                  </div>
                </div>
                <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                  {creator.category}
                </span>
              </div>

              <p className="mt-4 text-sm font-medium leading-relaxed text-primary-700">
                {creator.signature}
              </p>
              <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {creator.description}
              </p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {creator.focus.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-md bg-background-200/70 px-2 py-1 text-[11px] text-foreground-700"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}